class OneModule {
  constructor({ tid, cmpType, name, data = JSON.parse(JSON.stringify(window.Style_list_config[cmpType])) }) {
    this.tid = tid
    // for (const key in data) {
    //   console.log(key, 'dddddd')
    //   if (key) this[key] = data[key]
    // }
    var keys = Object.keys(data)
    keys.forEach(item => {
      this[item] = data[item]
    })
    if (name) this.name = name
    if (cmpType) {
      this.cmpType = cmpType
      this.type = `basic_${cmpType}`
    }
  }
}

export default OneModule
